<template>
<div class="container">
<mt-navbar v-model="selected">
  <mt-tab-item id="1">VIP会员卡</mt-tab-item>
  <mt-tab-item id="2">VIP优惠券</mt-tab-item>
  <mt-tab-item id="3">商城优惠券</mt-tab-item>
</mt-navbar>

<mt-tab-container v-model="selected" class="content">
  <mt-tab-container-item :id="'1'">
<div class="row" v-show="!list||list.length==0">
    <p class="center">
       <i class="fa fa-credit-card card"></i>
    </p>
    <p class="center gray">暂无会员卡</p>
</div>      
<div class="row setpsd" v-show="list.length>0">
    <div class="col-10 pd">
        <mt-button size="large" type="primary" @click="set">修改会员卡密码</mt-button>
    </div>
    <div class="col-10 mt" v-show="status">
        <ul class="list">
            <li class="item" v-for="v in list" :key="v.id">
                卡号：{{v.vipnumber}} [ {{v.lb}} ] 
                <mt-button @click="setpsd(v)" class="fr">设置密码</mt-button>
            </li>
        </ul>
    </div>

    <div class="row" v-show="showform">
        <h3 class="center">卡号：{{f.vipnumber}} ({{f.lb}})</h3>
        <mt-field label="原密码" type="password" placeholder="请输入原密码，初始密码为空" v-model="f.old"></mt-field>
        <mt-field label="新密码" type="password" placeholder="请输入新密码" v-model="f.psd1"></mt-field>
        <mt-field label="确认密码" type="password" placeholder="请再次输入新密码" v-model="f.psd2"></mt-field>
        <div class="row pd">
            <mt-button size="large" type="primary" @click="sub">确 定</mt-button>
        </div>
    </div>   

</div> 


    <div class="row">
            <ul class="list">
              <li class="item" v-for="v in list" :key="v.id">
                    <a class="thumbnail">
                        <img src="/Public/images/vip.png" alt="第一健康会员卡">
                        <b class="title">{{v.lb}}</b>
                        <b class="yer">余额：{{v.zhye}} 元</b>
                        <b class="time">开卡时间：{{v.xsrq.substr(0,10)}}</b>
                        <b class="card">卡 号：{{v.vipnumber}}</b>
                    </a>
              </li>
            </ul>          
    </div>
    
  </mt-tab-container-item>



<mt-tab-container-item :id="'2'" class="content">
<div class="row" v-show="!coupon||coupon.length==0">
    <p class="center">
       <i class="fa fa-credit-card card"></i>
    </p>
    <p class="center gray">暂无优惠券</p>
</div>   

  <ul class="list">
    <li class="item" v-for="v in coupon" :key="v.id">
        <a class="thumbnail cp">
            <img src="/Public/images/coupon.png" alt="第一健康礼品卡"/>
            <p class="title">{{v.wpmc}}</p>
            <p class="other">剩余：{{v['剩余']}}&nbsp;&nbsp;&nbsp; 已用：{{v['已用']}} &nbsp;&nbsp;&nbsp;总数：{{v['总数']}}</p>
       </a>
    </li>
  </ul>

</mt-tab-container-item>

<!-- 商城优惠券 -->
<mt-tab-container-item :id="'3'">
    <card :card="mycard" :type="2" @select="select_mycard"></card>

    <div class="row" v-show="!mycard||mycard.length==0">
        <p class="center">
            <i class="fa fa-credit-card card"></i>
        </p>
        <p class="center gray">暂无商城优惠券</p>
    </div>  
</mt-tab-container-item>
   
</mt-tab-container>


</div>
</template>   

<style scopde>
.content{border-top:1px solid #ddd;}
.pd{padding:.5rem;margin-bottom:.5rem;}
.item{position:relative;}
.thumbnail b{position: absolute;color:white;display: inline-block;}
b.title{top:40%;left:30%;font-size:2rem;letter-spacing:.3rem;}
b.yer{top:60%;left:30%;padding-left:.5rem;}
b.time{bottom:.9rem;left:1rem;font-size:.8rem;}
b.card{bottom:.9rem;right:1rem;font-size:.8rem;}
.setpsd{padding:.5rem 0;}
.fr{float:right;margin-top:-0.2rem;}
.mt{margin-top:.5rem;}

.thumbnail p{position: absolute;color:#0090FF;display: inline-block;}
p.title{top:35%;left:8%;font-weight:500;}
p.other{top:55%;left:8%;font-weight:500;}
h3{padding:.5rem;}
i.card{font-size:3rem;padding:1rem;color:#0090FF;margin-top:3rem;}
</style>

<script>
import card from "../../lib/card.vue";

export default {
    data(){
        return {
            selected:"1",
            list:[],
            coupon:[],
            mycard:[],
            hadload:false,
            status:false,
            f:{old:"",psd1:"",psd2:"",lb:"",vipnumber:"",vipid:""},
            showform:false,
        }
    },
    components:{card},
    created(){
        this.$emit("setTitle","卡券管理");
        this.init();
    },
    methods:{
        init:function(){
            var _this=this;
            fun.post(mydata.host+"/Apiall/Member/get_card",{},function(d){
                console.log(d)
                if(d.status==1){
                    _this.list=d.info;
                }else{
                _this.$toast(d.info);
                }
            },true)
            _this.get_coupon();
            _this.get_my_all_card();
        },
        get_my_all_card:function(){
           var _this=this;
           fun.post(mydata.api+"Member/get_my_all_card",{},function(d){
               fun.log(d)
               if(d.status==1){
                   _this.mycard=d.info;
                   _this.mycard.sort(function(a,b){
                       return a.status-b.status;
                   })
               }
           })
        },
        select_mycard(d){
              fun.log(d);
            if(d.status!=1){return;}  
            this.$router.push("/mall");   
        },
        set:function(){
            this.status=!this.status;
            if(!this.status){this.showform=false;}
        },
        setpsd:function(v){
            this.f.vipid=v.vipid;
            this.f.vipnumber=v.vipnumber;
            this.f.lb=v.lb;
            this.showform=true;
        },
        sub:function(){
            var _this=this;
            fun.post(mydata.host+"/Apiall/Member/change_card_psd",this.f,function(d){
                console.log(d)
                _this.$toast(d.info);
                if(d.status==1){
                _this.showform=false;
                _this.f.old="";
                _this.f.psd1="";
                _this.f.psd2="";
                }
            })
        },
        get_coupon:function(){
         var _this=this;
         fun.post(mydata.host+"/Apiall/Member/get_coupon",{},function(d){
             console.log(d)
             _this.hadload=true;
             if(d.status==1){
                 _this.coupon=d.info;
             }
         },true)
     }
    }
}

</script>


// WEBPACK FOOTER //
// src/components/user/card.vue